import { nation, nation1 } from "./fieldOptions/dict";
import { CustomFormItemType,Busdictlist } from "@/components/CustomFormItem/CustomFormItemType";

export const formConfig = (data = {}) => [
    {
        type: "text",
        label: "姓名",
        name: "realName",
        value: data.realName,
        placeholder: "请输入姓名",
    },
    {
        type: "area",
        label: "籍贯",
        name: "orgName",
        value: data.orgName,
        placeholder: "请输入籍贯",
    },
    {
        type: "select",
        label: "民族",
        name: "nation",
        value: data.nation,
        placeholder: "请选择民族",
        // options: nation
    },
    {
        type: "select",
        label: "政治面貌",
        name: "veteransOutlook",
        value: data.veteransOutlook,
        placeholder: "请选择政治面貌",
        // type: CustomFormItemType.SELECT,
        // code: Busdictlist.poli_affi_code,
        options: [
            {value: "01",label: "中国共产党党员",},
            {value: "02",label: "中国共产党预备党员",},
            {value: "03",label: "中国共产主义青年团团员",},
            {value: "04",label: "中国国民党革命委员会会员",},
            {value: "05",label: "中国民主同盟盟员",},
            {value: "06",label: "中国民主建国会会员",},
            {value: "07",label: "中国民主促进会会员",},
            {value: "08",label: "中国农工民主党党员",},
            {value: "09",label: "中国致公党党员",},
            {value: "10",label: "九三学社社员",},
            {value: "11",label: "台湾民主自治同盟盟员",},
            {value: "12",label: "无党派民主人士",},
            {value: "13",label: "群众",}
        ],
    },
    {
        type: "text",
        label: "手机号码",
        name: "phone",
        value: data.phone,
        placeholder: "请输入手机号码",
    },
    {
        type: "text",
        label: "电子邮箱",
        name: "email",
        value: data.email,
        placeholder: "请输入电子邮箱",
    },
    {
        type: "text",
        label: "身份证号码",
        name: "idCardNum",
        value: data.idCardNum,
        placeholder: "请输入身份证号码",
    },
    {
        type: "text",
        label: "详细地址",
        name: "detailedAddress",
        value: data.detailedAddress,
        placeholder: "请输入详细地址",
    },
    {
        type: "text",
        label: "户口簿地址",
        name: "householdAddress",
        value: data.householdAddress,
        placeholder: "请输入户口簿地址",
    },
    {
        type: "text",
        label: "现居住地址",
        name: "currentPlace",
        value: data.currentPlace,
        placeholder: "请输入现居住地址",
    },
    {
        type: "text",
        label: "特长",
        name: "speciality",
        value: data.speciality,
        placeholder: "请输入特长",
    },
    // {
    //     type: "select",
    //     label: "培训意向",
    //     name: "isWillingTrain",
    //     value: data.isWillingTrain || 0,
    //     placeholder: "请输入培训意向",
    //     options: [
    //         {
    //             value: 0,
    //             label: "愿意",
    //         },
    //         {
    //             value: 1,
    //             label: "不愿意",
    //         }
    //     ],
    // },
];